// extracted by mini-css-extract-plugin
export default {"content":"isni-credit_content__J4F7R","icon":"isni-credit_icon__YrkDx","bold":"isni-credit_bold__dKqXN"};